 
$(document).ready(function () {
    $(function () {
        $('#sectores').change(function () {
           // localStorage.setItem('todoData', this.value);
           // console.log(this.value);
            if (this.value == 'Bogotá') {
                $(".select-localidad-location").css("display", "block");
            } else {
                $(".select-localidad-location").css("display", "none");
            }
           // console.log('hola');
        });

        setTimeout(function(){
            if(localStorage.getItem('todoData')){
              $('#sectores').val(localStorage.getItem('todoData'));
            } else {
              localStorage.setItem("todoData", "Bogotá");
            }
          }, 1000);

        $('.btn-locations-tooltip').click(function () {
            localStorage.setItem('clickLocation', 'click');
        });
        if (localStorage.getItem('clickLocation')) {
            $('.btn-locations-tooltip').val(localStorage.getItem('clickLocation'));
        }
    });
});


$(function() {
    $('.js-btn-save-city').on('click',function(e){
      e.preventDefault();
      localStorage.setItem('todoData', $('#sectores').val());
      $.ajax({
        type: "POST",
        url: '/cart/clear.js',
        success: function(){
            window.location.href = "/";
        },
        dataType: 'json'
      });
    })
  });

$('.js-btn-save-city').click(function () {
 
});


function ShowSelected() {
    /* Para obtener el texto */
    var combo = document.getElementById("sectores");
    var selected = combo.options[combo.selectedIndex].text;
}

$(".cancel-location").click(function () {
    $(".tooltip-location").css("display", "none")
});

$(".change-location").click(function () {
    $(".tooltip-location").css("display", "none")
});


let locationClick = localStorage.getItem('clickLocation');
let aValue = localStorage.getItem('todoData');

if (aValue == 'Bogotá') {
    $(".select-localidad-location").css("display", "block");
    console.log("test");
} else {
    $(".select-localidad-location").css("display", "none");
    console.log("none");
}

if (localStorage.getItem('clickLocation') !== undefined && localStorage.getItem('clickLocation')) {
    $(".tooltip-location").css("display", "none")
    console.log('click');
} else {
    $(".tooltip-location").css("display", "block")
}


let product_id_l = $("#product_id_localization").text();

let inventory_item_id = null;

/**
 *
 */
const getProduct = async () => {
    const result = await axios
        .get()
        .then((response) => {
            inventory_item_id = response.data.product.variants[0].inventory_item_id;
            getLocations();
        })
        .catch((err) => {
            console.log(err);
        });
};

/**
*
*/
const getLocations = () => {
    axios
        .get()
        .then((response) => {
            var petitions = [];
            response.data.locations.map((item) => {
                petitions.push(getInventoryLevels(item.id));
            });
            Promise.all(petitions).then((res) => {
                res.map((item) => {
                    if (item) {
                        getLocationsName(item.location_id, item.available);
                    }
                });
            });
        })
        .catch((err) => {
            console.log(err);
        });
};

/**
*
* @param id
* @returns
*/
const getInventoryLevels = async (id) => {
    return await axios
        .get()
        .then((response) => {
            return {
                location_id: response.data.inventory_levels[0].location_id,
                available: response.data.inventory_levels[0].available,
            };
        })
        .catch((err) => {
            console.log(err);
        });
};

/**
* 
* @param location_id 
* @param available 
* @returns 
*/
const getLocationsName = async (location_id, available) => {
    return await axios
        .get()
        .then((res) => {
            const location = res.data.locations.filter((x) => x.id === location_id)[0]
                .name;
            console.log(location, available);


            setTimeout(function () {

                if (location == aValue && available > 0) {
                    $("#fname").append('<p>Cantidad disponible: <span class="color-stock">' + available + '</span></p>');
                } else if (available == 0 && location == aValue) {
                    $("#fname").append('<p class="color-stock">No disponible en tu ciudad</p><p class="drop-recomendate">Tambien puedes comprar</p>');
                }


                $("input[value=" + aValue + "]").click();

                $(".drop-recomendate").on("click", function () {
                    var posicion = $(".scroll-avaliable").offset().top;
                    $("html, body").animate({
                        scrollTop: posicion
                    }, 2000);
                });

            }, 1000);

            return { location, available };
        })
        .catch((err) => {
            console.log(err);
        });
};

getProduct();